import React from 'react';
import {classes, style} from './doppe-action-type-widget-inner-button.st.css';
import {Button, DoubleRingSpinner, Icon} from '@wix/devzai-utils-react';
import {FlexLayout} from '@wix/devzai-common-client';

export const DoppeActionTypeWidgetInnerButton = React.memo(function DoppeActionTypeWidgetInnerButton(props: DoppeActionTypeWidgetInnerButton.Props) {
    const {
        isLoading,
        children,
        disabled,
        inPopup = false,
        suffixIcon,

        className,
        ...htmlAttributes
    } = props;

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.root, {
                inPopup: inPopup,
                hasSuffixIcon: suffixIcon !== undefined,
            }, className)}
            disabled={disabled || isLoading}
        >
            <div
                className={style(classes.textContent, {}, FlexLayout.column.default)}
            >
                {children}
            </div>
            {
                suffixIcon ?
                    <Icon
                        className={style(classes.suffixIcon, {})}
                        icon={suffixIcon}
                    />
                    :
                    null
            }
            {isLoading ? (
                <div
                    className={style(classes.loadingState, {})}
                >
                    <DoubleRingSpinner
                        className={style(classes.spinner, {})}
                    />
                    {'Please Wait...'}
                </div>
            ) : null}
        </Button>
    );
});

export namespace DoppeActionTypeWidgetInnerButton {

    export interface Props extends Button.Props {
        isLoading?: boolean;
        inPopup?: boolean;
        suffixIcon?: Icon.Src;
    }

}
